import { tagMetadataKeys } from '../export/tagMetadataKeys.js'
import { contactsExportType } from '../const/contactsExportType.js'
import type {
	ContactsIteratorResult,
	ExportMetadataItem,
	IBroker
} from './types.js'

export class CsvListContactsIterator {
	// @ts-ignore
	readonly #broker: IBroker
	#currentIndex: number
	readonly #contacts: unknown[]

	constructor(broker: IBroker, contacts: unknown[]) {
		this.#broker = broker
		this.#contacts = contacts
		this.#currentIndex = -1
	}

	async getNext(_metadata?: object): Promise<ContactsIteratorResult> {
		let result: ContactsIteratorResult | null
		do {
			result = await this.#getNext()
		} while (!result?.found.length && this.canMove())
		result = result ?? { found: [], processed: 0 }
		return result
	}

	canMove(): boolean {
		return this.#currentIndex < this.#contacts.length - 1
	}

	getTotal(): number {
		return this.#contacts.length
	}

	getMetadata(): ExportMetadataItem[] {
		const result = [
			{
				key: tagMetadataKeys.ExportStartedKey,
				value: tagMetadataKeys.TrueValue
			}
		]
		return result
	}

	getType(): string {
		return contactsExportType.csvContactsList
	}

	async #getNext(): Promise<ContactsIteratorResult> {
		const result: ContactsIteratorResult = {
			found: [],
			processed: 0
		}
		for (
			this.#currentIndex++;
			this.#currentIndex < this.#contacts.length;
			this.#currentIndex++
		) {
			const contact = this.#contacts[this.#currentIndex]
			result.found.push(contact)
			result.processed++
			if (result.processed >= 50) {
				break
			}
		}
		return result
	}
}
